<!-- este sirve como un popup que termina un arbol de paneles; ya no puede abrir otro -->
<div class="popup" *ngIf="!isLoading">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}">
      <loading [isLoading]="isLoading"></loading>

      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">

          <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
            <mat-icon>arrow_back_ios</mat-icon>
          </div>
  
            <!-- Encabezado -->
            <div *ngIf="images.length == 0" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                <img [src]="locationDTO.panelIcon | findUrl" class="header-img" />

                <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                    <label class="subtitlePanel" [matTooltip]="this.locationDTO.description"> {{this.locationDTO.description | slice:0:20}}</label>

                    <label class="vin-title-container"> 
                      <div class="vin-title">
                        {{ this.locationDTO.identifier | slice:0:24}}
                      </div>
                    </label>
                    
                </div>

                <div class="tool-opener" (click)="toggleToolButton()">
                  <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
                  <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
                </div>
            </div>

            <!-- carrusel -->
            <div *ngIf="images.length > 0 && mobileQuery.matches" class="header-carousel" [ngClass]="{'col-3': !mobileQuery.matches}">
              <carousel [images]="images"></carousel>
            </div>

            <!-- seccion de herramientas -->
            <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical details-tool-list-for-tutorial">
              <location-button-toolbar *ngIf="!isLoading" 
                [identifier]="locationDTO.identifier"
                [description]="locationDTO.description" 
                [isDetailLocations]="true" 
                [isLoadingParent]="isLoading"
                [isMonitor]="false"
                [images]="images"
                [isLoadingImages]="isLoadingImages"
                [hasRouteTrace]="false"
                [isVerticalList]="true">
              </location-button-toolbar>
              
              <!-- <app-report-list [identifier]="locationDTO.identifier"
                [description]="locationDTO.description" 
                              [isDetailLocations]="true"
                              [isVerticalList]="true"></app-report-list> -->
            </div>
  
        </div>
        <!-- seccion de tabs -->
        <div class="tab-group">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)" class="details-tab-group">
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above"> Detalle Activo </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                    <!-- primera sección -->
                    <div class="data-section-container">
                      <div class="text-header">
                        <h3>Datos Generales</h3>
                      </div>
      
                      <!-- datos generales -->
                        <div class="row-data">
                          <div class="">
                            <label class="titlePanel">Categoría</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ getUsableName(this.locationCategoryShortName) }}</div>
                          </div>
                        </div>
                        <div class="row-data" *ngIf="!!this.locationDTO.group">
                          <div class="">
                            <label class="titlePanel">Grupo</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ this.locationDTO.group.name }}</div>
                          </div>
                        </div>
                        <div class="row-data" *ngIf="!!this.locationDTO.subGroup">
                          <div class="">
                            <label class="titlePanel">Sub grupo</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ this.locationDTO.subGroup.name }}</div>
                          </div>
                        </div>
                      
                    </div>
                      
      
                    <!-- Segunda sección datos del activo-->
                    <div class="data-section-container" *ngIf="!isLoading && !!detallesActivo && detallesActivo.length > 0">
                      <div class="text-header">
                        <h3>Datos del Activo</h3>
                      </div>
      
                      <div *ngFor="let key of detallesActivo; let i = index" >
                        <div *ngIf="getNameVisibility(key)" class="row-data">
                          <div class="">
                            <label class="titlePanel">{{ getUsableName(key) }}</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ values[keys.indexOf(key)] }}</div>
                          </div>
                        </div>  
                      </div>
      
                    </div>
      
                    <!-- Tercera sección Datos GPS-->
                    <div class="data-section-container" *ngIf="!isLoading && !!detallesGPS && detallesGPS.length > 0">
                      <div class="text-header">
                        <h3>Datos del GPS</h3>
                      </div>
              
                      <div *ngIf="getNameVisibility('StatusGPS')" class="row-data">
                        <div class="">
                          <label class="titlePanel">{{ getUsableName('Estado del GPS') }}</label>
                        </div>
                        <div class="">
                          <div class="general-data">{{ locationDTO.gpsStatus }}</div>
                        </div>
                      </div>
              
                      <div *ngFor="let key of detallesGPS; let i = index" >
                        <div *ngIf="getNameVisibility(key)" class="row-data">
                          <div class="">
                            <label class="titlePanel">{{ getUsableName(key) }}</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ values[keys.indexOf(key)] }}</div>
                          </div>
                        </div>
                      </div>
      
      
                    </div>
                </div>
              </ng-template>
            </mat-tab>
            
            <div *ngFor="let routeSheet of routeSheets; let i = index">
              <mat-tab  class="categoryTabLabel">
                <ng-template mat-tab-label>
                  <!-- <img [src]="routeSheet.category.icon | findUrl" width="30px" class="mr-5">  -->
                  <label matTooltipPosition="above">
                    {{ routeSheet.total }} {{routeSheet.routeSheetName }}
                  </label>
                </ng-template>

                <ng-template matTabContent>
                  <div class="tab-content-wrapper">
                    <div [ngClass]="{'container': mobileQuery.matches}">
                       <!-- asociados  -->
                      <app-route-sheet *ngIf="selectedTabIndex === i+1" [identifier]="this.locationDTO.identifier" 
                                                                        [childCategory]="routeSheet.routeSheetIdLocationCategory"
                                                                        [parentCategory]="this.locationDTO.idLocationCategory"
                                                                        [parentCoordX]="this.locationDTO.cordsX"
                                                                        [parentCoordY]="this.locationDTO.cordsY"
                                                                        (categoryTotal)="loadTotal($event, routeSheet)">
                      </app-route-sheet>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </div>
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>

  <details-skeleton-loader *ngIf="isLoading"></details-skeleton-loader>